import styled from '@emotion/styled';

import LayoutContainer from 'components/LayoutContainer';
import Text from 'components/Text';
import { respondTo } from 'styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Header = styled.header`
  background-color: ${(props) => props.theme.brand.primary};
  position: relative;
  padding: 72px 0;
  overflow: hidden;

  ${respondTo.mobile} {
    padding: 32px 0;
  }
`;

export const HeaderContent = styled(LayoutContainer)`
  text-align: center;
  padding: 0 16px;
  width: 100%;
`;

export const Triangle = styled.div`
  --h: 164px;
  --w: 225px;
  width: 0;
  height: 0;
  border-left: var(--w) solid transparent;
  border-right: var(--w) solid transparent;
  border-top: var(--h) solid ${(props) => props.theme.foreground.primary};
  pointer-events: none;
  position: absolute;
  top: 0;
  right: calc((var(--w)) * -1);

  ${respondTo.mobile} {
    --h: 48px;
    --w: 96px;
  }
`;

export const HeaderTitle = styled(Text)`
  font-weight: 800;
`;

export const Content = styled(LayoutContainer)`
  padding: 32px 16px 64px;
  width: 100%;
  max-width: 1024px;

  & > *:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const Card = styled.div`
  background: ${(props) => props.theme.surface.primary};
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.08);
  border-radius: 15px;
  display: flex;
  padding: 32px 32px 32px 0;

  ${respondTo.mobile} {
    flex-direction: column;
    padding: 20px 20px 20px 0;
  }
`;

export const CardLeft = styled.div`
  background-color: #f05d4f;
  border-radius: 0px 10px 10px 0px;
  padding: 16px 16px 16px 20px;
  margin-right: 64px;
  align-self: flex-start;
  flex-basis: 254px;

  ${respondTo.mobile} {
    margin: 0 0 20px 0;
    flex-basis: initial;
  }
`;

export const Caption = styled(Text)`
  color: ${(props) => props.theme.surface.primary};
`;

export const CardRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${respondTo.mobile} {
    flex: initial;
    padding-left: 20px;
  }
`;

export const PlanName = styled(Text)`
  color: #373e5c;
`;

export const PlanTitle = styled(Text)`
  color: ${(props) => props.theme.foreground.primary};
  font-weight: 700;
  margin-top: 20px;
`;

export const PlanDescription = styled(Text)`
  color: ${(props) => props.theme.foreground.primary};
  margin: 24px 0;
  letter-spacing: 0.04em;
`;
